import { render } from "./NCG.vue?vue&type=template&id=e0aee2a6&scoped=true"
import script from "./NCG.vue?vue&type=script&lang=js"
export * from "./NCG.vue?vue&type=script&lang=js"

import "./NCG.vue?vue&type=style&index=0&id=e0aee2a6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0aee2a6"]])

export default __exports__